export default __webpack_public_path__ + "assets/vistoo-logo-white.3bc3be2a.png";